import HawkRequester from 'hawk-requester';

class KaiStoreHawkHelper {
  constructor() {
    this._kid = null;
    this._macKey = null;
    this._customConnectionType = null;
  }

  get isTokenSet() {
    return this.kid !== null && this._macKey !== null;
  }

  _getDefaultConnectionType(deviceInfos) {
    this._hasValidDeviceInfos({
      deviceInfos,
      validateKeys: [
        'ril.data.defaultServiceId'
      ]
    });
    const defaultServiceId = deviceInfos.get('ril.data.defaultServiceId');

    if (
      navigator.mozWifiManager &&
      navigator.mozWifiManager.connection.status === 'connected'
    ) {
      return 'wifi';
    } else {
      const conns =
        window.navigator.mozMobileConnection ||
        window.navigator.mozMobileConnections;
      return conns[defaultServiceId].data.type;
    }
  }

  _getConnectionType({
    useCustom = false,
    deviceInfos
  }){
    if (useCustom) {
      return this._customConnectionType;
    } else {
      return this._getDefaultConnectionType(deviceInfos);
    }
  }

  _getTimeZoneOffset() {
    const t = new Date();
    const tzo = t.getTimezoneOffset();
    return tzo === 0 ? tzo : -(tzo / 60);
  }

  _getTimeStamp() {
    const t = new Date();
    const tzo = -t.getTimezoneOffset();
    const dif = tzo >= 0 ? '+' : '-';
    return (
      `${t.getFullYear()}-` +
      `${this._formatedTime(t.getMonth() + 1)}-` +
      `${this._formatedTime(t.getDate())}T` +
      `${this._formatedTime(t.getHours())}:` +
      `${this._formatedTime(t.getMinutes())}:` +
      `${this._formatedTime(t.getSeconds())}:` +
      `${dif}` +
      `${this._formatedTime(Math.abs(tzo / 60))}:` +
      `${this._formatedTime(Math.abs(tzo % 60))}`
    );
  }

  _formatedTime(time) {
    return time.toString().padStart(2, '0');
  }

  _hasValidDeviceInfos({ deviceInfos, validateKeys }) {
    if (!(deviceInfos instanceof Map) || !deviceInfos.size) {
      // DeviceInfos not type of Map or deviceInfos Map is empty.
      console.error('ArgumentError: Expected deviceInfos Map to not be empty');
      return false;
    }

    if (typeof validateKeys === 'undefined' || validateKeys.length === 0) {
      // No need to validate DeviceInfos keys.
      return true;
    }

    // Start to validate DeviceInfos keys.
    const missingKeys = [];

    validateKeys.forEach(key => {
      if (!deviceInfos.has(key)) {
        missingKeys.push(key);
      }
    });

    if (missingKeys.length > 0) {
      console.error(
        `ArgumentError: Expected Map to have keys [${missingKeys.toString()}]`
      );
      return false;
    }
    return true;
  }

  getRequester({
    serverTimeOffset,
    setDeviceInfo = true,
    deviceInfos,
    useCustomConnectionType = false
  }) {
    if (!this.isTokenSet) {
      return null;
    }

    if (setDeviceInfo) {
      this._hasValidDeviceInfos({
        deviceInfos,
        validateKeys: [
          'deviceinfo.platform_build_id',
          'deviceinfo.build_number'
        ]
      });
    }

    const requester = new HawkRequester();
    requester.setHawkCredentials(this._kid, this._macKey);

    if (serverTimeOffset) {
      requester.serverTimeOffset = serverTimeOffset;
    }

    if (setDeviceInfo === true) {
      const buildID = deviceInfos.get('deviceinfo.platform_build_id');
      const buildNumber = deviceInfos.get('deviceinfo.build_number');

      requester.setDeviceInfo({
        ct: this._getConnectionType({
          useCustom: useCustomConnectionType,
          deviceInfos: deviceInfos
        }),
        utc: this._getTimeStamp(),
        utcOff: this._getTimeZoneOffset(),
        buildID,
        buildNumber
      });
    }

    return requester;
  }

  generateURL({ apiName, params, deviceInfos }) {
    let apiURI = '';
    if (
      this._hasValidDeviceInfos({
        deviceInfos,
        validateKeys: ['apps.serviceCenterUrl']
      })
    ) {
      apiURI = `${deviceInfos.get('apps.serviceCenterUrl')}/`;
    }

    let append = Object.entries(params).reduce(
      (acc, [key, value]) => acc.concat('&', key, '=', value),
      ''
    );

    if (append.length > 0) {
      append = `?${append.slice(1)}`;
    }
    return `${apiURI}${apiName}${append}`;
  }

  setToken(kid, macKey) {
    this._kid = kid;
    this._macKey = macKey;
  }

  setCustomConnectionType(type) {
    this._customConnectionType = type;
  }
}

export default KaiStoreHawkHelper = new KaiStoreHawkHelper();



/** WEBPACK FOOTER **
 ** ./~/kaistore-hawk-helper/lib/index.js
 **/